import classes from "./profileBox.module.css";
import Me from "../../../assets/images/Hero/vs-circle.png";
import Insta from "../../../assets/images/techIcons/instagram.png";
import Linkdin from "../../../assets/images/techIcons/linkedin.png";
import xt from "../../../assets/images/techIcons/twitter-alt.png";
import git from "../../../assets/images/techIcons/github.png";

const ProfileBox = () => {
  const socialLinks = [
    {
      id: 1,
      name: "Instagram",
      icon: Insta,
      url: "https://www.instagram.com/vivekshxrma.me/" // Replace with your actual URLs
    },
    {
      id: 2,
      name: "LinkedIn",
      icon: Linkdin,
      url: "https://www.linkedin.com/in/vivek-sharma-a6bb2b2b7/"
    },
    {
      id: 3,
      name: "Twitter/X",
      icon: xt,
      url: "https://x.com/VivekkShxrma"
    },
    {
      id: 4,
      name: "GitHub",
      icon: git,
      url: "https://github.com/Codester06"
    }
  ];

  return (
    <>
      <div className={classes.profileBox}>
        <div className={classes.profileImage}>
          <img src={Me} alt="Vivek Sharma" />
        </div>
        <div className={classes.profileName}>Vivek Sharma</div>
        <p className={classes.profileDescription}>
          Feel free to reach out if you're interested in working together! 🌐
        </p>
        <div className={classes.linksS}>
          {socialLinks.map((link) => (
            <a 
              key={link.id}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.LinkSocial}
              title={link.name}
            >
              <img src={link.icon} alt={link.name} />
            </a>
          ))}
        </div>
      </div>
    </>
  );
};

export default ProfileBox;